module.exports = __webpack_public_path__ + "static/img/banner-vip.29539bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/banner-vip.png
// module id = tec/
// module chunks = 96